
import { Component, Prop, Vue } from 'vue-property-decorator';
import { UserModule } from '../../store/modules/user';

import DialogSetStaff from '../staff/components/setStaff.vue';
import DialogImgLarge from '@/components/ImgLarge/index.vue';
import { getPersonStatisticsListNew, personStatisticsExport } from '@/api/stock';

@Component({
  name: 'StockPersonStatisticsNew',
  components: {
    DialogSetStaff,
    DialogImgLarge
  }
})
export default class extends Vue {
  private formSearch:any = {
    startTime: '',
    endTime: '',
    staff: {},
    category: '',
    name: '',
    model: '',
    serial: '',
    specification: ''
  }
  private pagination: any = {
    currentPage: 1,
    pageSize: 10,
    total: 0
  };
  private dialogSetStaffVisible = false
  private radioSelectedStaff = true
  private loading = false
  private dataTable = []

  private inoutSearchData:any={
    inout_user_id: '',
    inout_user_name: '',
    p_stock_name: '',
    stock_name: '',
    model_name: '',
    type: ''
  }

  created() {
    this.getPersonStatisticsList();
  }

  private handlePageSizeChange(val:any) {
    this.pagination.pageSize = val;
    this.getPersonStatisticsList();
  }
  private handleCurrentChange(val:any) {
    this.pagination.currentPage = val;
    this.getPersonStatisticsList();
  }
  private selectedStaffHandle(val:any) {
    this.formSearch.staff = val;
  }
  private getPersonStatisticsList() {
    const params:any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      user_name: UserModule.getUserName,
      company_name: UserModule.getCompanyName,
      page: this.pagination.currentPage,
      size: this.pagination.pageSize
    };
    if (this.formSearch.startTime) {
      params.start_time = this.formSearch.startTime / 1000;
    }
    if (this.formSearch.endTime) {
      params.end_time = this.formSearch.endTime / 1000;
    }
    params.inout_user_id = this.formSearch.staff.id;
    params.p_stock_name = this.formSearch.category;
    params.stock_name = this.formSearch.name;
    params.model_name = this.formSearch.model;
    params.serial_number = this.formSearch.serial;
    params.specification = this.formSearch.specification;
    getPersonStatisticsListNew(params).then((res:any) => {
      if (res.data) {
        this.pagination.total = res.data.count;
        this.dataTable = res.data.list;
      } else {
        this.pagination.total = 0;
        this.dataTable = [];
      }
    }).catch((error) => {
      this.pagination.total = 0;
      this.dataTable = [];
      let msg = error.msg;
    });
  }
  private search() {
    this.pagination.currentPage = 1;
    this.getPersonStatisticsList();
  }
  private reset() {
    this.formSearch = {
      startTime: '',
      endTime: '',
      staff: {},
      category: '',
      name: '',
      model: '',
      serial: '',
      specification: ''
    };
    this.pagination.currentPage = 1;
    this.getPersonStatisticsList();
  }
  private personStatisticsExport() {
    const params:any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      user_name: UserModule.getUserName,
      company_name: UserModule.getCompanyName,
      page: this.pagination.currentPage,
      size: this.pagination.pageSize
    };
    if (this.formSearch.startTime) {
      params.start_time = this.formSearch.startTime / 1000;
    }
    if (this.formSearch.endTime) {
      params.end_time = this.formSearch.endTime / 1000;
    }
    params.inout_user_id = this.formSearch.staff.id;
    params.p_stock_name = this.formSearch.category;
    params.stock_name = this.formSearch.name;
    params.model_name = this.formSearch.model;
    params.serial_number = this.formSearch.serial;
    params.specification = this.formSearch.specification;
    personStatisticsExport(params).then((res:any) => {
      this.$confirm('是否跳转下载页面？', '跳转', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let routeData = this.$router.resolve({
          path: '/ExportTask',
          query: {}
        });
        window.open(routeData.href);
      }).catch(() => {

      });
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }
  private closeStaff(val: any) {
    this.dialogSetStaffVisible = val;
  }
  private selectStaff() {
    this.dialogSetStaffVisible = true;
  }

  private cleanInoutSearchData() {
    this.inoutSearchData = {
      inout_user_id: '',
      inout_user_name: '',
      p_stock_name: '',
      stock_name: '',
      model_name: '',
      type: ''
    };
  }

  private jumpToInout() {
    this.$router.push({
      path: 'inout',
      query: { 'data': JSON.stringify(this.inoutSearchData) }
    });
  }

  private inRecord(val:any) {
    this.cleanInoutSearchData();
    this.inoutSearchData.inout_user_id = val.inout_user_id;
    this.inoutSearchData.inout_user_name = val.inout_user_name;
    this.inoutSearchData.type = '1';
    this.jumpToInout();
  }
  private outRecord(val:any) {
    this.cleanInoutSearchData();
    this.inoutSearchData.inout_user_id = val.inout_user_id;
    this.inoutSearchData.inout_user_name = val.inout_user_name;
    this.inoutSearchData.type = '2';
    this.jumpToInout();
  }
  private categoryInRecord(val:any) {
    this.cleanInoutSearchData();
    this.inoutSearchData.inout_user_id = val.inout_user_id;
    this.inoutSearchData.inout_user_name = val.inout_user_name;
    this.inoutSearchData.p_stock_name = val.p_stock_name;
    this.inoutSearchData.type = '1';
    this.jumpToInout();
  }
  private categoryOutRecord(val:any) {
    this.cleanInoutSearchData();
    this.inoutSearchData.inout_user_id = val.inout_user_id;
    this.inoutSearchData.inout_user_name = val.inout_user_name;
    this.inoutSearchData.p_stock_name = val.p_stock_name;
    this.inoutSearchData.type = '2';
    this.jumpToInout();
  }
  private stockInRecord(val:any) {
    this.cleanInoutSearchData();
    this.inoutSearchData.inout_user_id = val.inout_user_id;
    this.inoutSearchData.inout_user_name = val.inout_user_name;
    this.inoutSearchData.stock_name = val.stock_name;
    this.inoutSearchData.type = '1';
    this.jumpToInout();
  }
  private stockOutRecord(val:any) {
    this.cleanInoutSearchData();
    this.inoutSearchData.inout_user_id = val.inout_user_id;
    this.inoutSearchData.inout_user_name = val.inout_user_name;
    this.inoutSearchData.stock_name = val.stock_name;
    this.inoutSearchData.type = '2';
    this.jumpToInout();
  }
  private modelInRecordFun(val:any) {
    this.cleanInoutSearchData();
    this.inoutSearchData.inout_user_id = val.inout_user_id;
    this.inoutSearchData.inout_user_name = val.inout_user_name;
    this.inoutSearchData.stock_name = val.stock_name;
    this.inoutSearchData.model_name = val.model_name;
    this.inoutSearchData.type = '1';
    this.jumpToInout();
  }
  private modelOutRecordFun(val:any) {
    this.cleanInoutSearchData();
    this.inoutSearchData.inout_user_id = val.inout_user_id;
    this.inoutSearchData.inout_user_name = val.inout_user_name;
    this.inoutSearchData.stock_name = val.stock_name;
    this.inoutSearchData.model_name = val.model_name;
    this.inoutSearchData.type = '2';
    this.jumpToInout();
  }

  private largeImage(val: any, index: number) {
    let value = [val];
    let enlargedData = {
      isShow: true,
      imgList: value,
      initNum: index
    };
    this.$store.dispatch('toggleEnlarged', enlargedData);
  }
  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }
}
